module.exports = {"name":"c4ki_admin","version":"3.6.4","private":true,"dependencies":{"axios":"^0.18.0","prop-types":"^15.6.2","react":"^16.4.2","react-dom":"^16.4.2","react-file-download":"^0.3.5","react-icons-kit":"^1.1.7","react-redux":"^5.0.7","react-router-dom":"^4.3.1","react-scripts":"1.1.5","redux":"^4.0.0","semantic-ui-css":"^2.3.3","semantic-ui-react":"^0.82.3","sweetalert":"^2.1.0"},"scripts":{"start":"react-scripts start","build":"react-scripts build","test":"react-scripts test --env=jsdom","eject":"react-scripts eject"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 785
// module chunks = 0